import img1 from "./image1.jpeg";
import img2 from "./image2.jpeg";
import img3 from "./image3.jpeg";
import img4 from "./image4.jpeg";
import img5 from "./image5.jpeg";
import img6 from "./image6.jpeg";
import img7 from "./image7.jpeg";
import img8 from "./image8.jpeg";
import img9 from "./image9.jpeg";
import img10 from "./WhatsApp Image 2025-11-25 at 3.34.05 PM.jpeg";
import img11 from "./WhatsApp Image 2025-11-25 at 3.34.06 PM (1).jpeg";
import img12 from "./WhatsApp Image 2025-11-25 at 3.34.06 PM (2).jpeg";
import img13 from "./WhatsApp Image 2025-11-25 at 3.34.06 PM.jpeg";
import img14 from "./WhatsApp Image 2025-11-25 at 3.34.07 PM (1).jpeg";
import img15 from "./WhatsApp Image 2025-11-25 at 3.34.07 PM (2).jpeg";
import img16 from "./WhatsApp Image 2025-11-25 at 3.34.07 PM (3).jpeg";
import img17 from "./WhatsApp Image 2025-11-25 at 3.34.07 PM.jpeg";
import img18 from "./WhatsApp Image 2025-11-25 at 3.34.08 PM (1).jpeg";
import img19 from "./WhatsApp Image 2025-11-25 at 3.34.08 PM (2).jpeg";
import img20 from "./WhatsApp Image 2025-11-25 at 3.34.08 PM.jpeg";
import img21 from "./WhatsApp Image 2025-11-25 at 3.34.09 PM (1).jpeg";
import img22 from "./WhatsApp Image 2025-11-25 at 3.34.09 PM (2).jpeg";
import img23 from "./WhatsApp Image 2025-11-25 at 3.34.09 PM.jpeg";
import img24 from "./WhatsApp Image 2025-11-25 at 3.34.10 PM (1).jpeg";
import img25 from "./WhatsApp Image 2025-11-25 at 3.34.10 PM (2).jpeg";
import img26 from "./WhatsApp Image 2025-11-25 at 3.34.10 PM.jpeg";
import img27 from "./WhatsApp Image 2025-11-25 at 3.34.11 PM (1).jpeg";
import img28 from "./WhatsApp Image 2025-11-25 at 3.34.11 PM (2).jpeg";
import img29 from "./WhatsApp Image 2025-11-25 at 3.34.11 PM.jpeg";
import img30 from "./WhatsApp Image 2025-11-25 at 3.34.12 PM.jpeg";
import img31 from "./WhatsApp Image 2025-11-30 at 8.59.25 AM.jpeg";

export default [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
  img14,
  img15,
  img16,
  img17,
  img18,
  img19,
  img20,
  img21,
  img22,
  img23,
  img24,
  img25,
  img26,
  img27,
  img28,
  img29,
  img30,
  img31,
];
